import React from "react";
import Tabla from "./Tabla";
import TablaArchivo from "./TablaInactivos";
import APL from "../../../assets/vw/svg/aplicaciones.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

class Aplicacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aplicaciones: [],
      aplicacionesInactivas: [],
      aplicacionesFiltradas: [],
      inactivasFiltradas:[],
      cargando: true,
      searchInput: "",
      tiposAutenticacion: [],
      option: "aplicaciones",
      dataOriginal: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(
        process.env.REACT_APP_URL_DTO_BACK + "tipoautenticacion?todos=todos",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      ).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      })
    ]).then(([responseBodyAplicaciones, responseBodyTipoAutenticacion]) => {
      const activas = responseBodyAplicaciones.mensaje.filter((aplicacion) => {
        return aplicacion.activo === 1;
      });

      this.setState(
        { 
          aplicaciones:activas, 
          dataOriginal: responseBodyAplicaciones.mensaje, 
          cargando: false,
          tiposAutenticacion: responseBodyTipoAutenticacion.mensaje
        });

    }).catch((errorP) => {
      this.setState({ cargando: false, modal: {
        active: true,
        message: errorP.message,
        success: false
      }
    });
      console.error(errorP.stack || errorP);
    });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearch();
      });
    }
  };

  globalSearch = () => {
    let { aplicaciones, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let aplicacionesFiltradas = aplicaciones.filter((value) => {
        return value.nombre.toLowerCase().includes(searchInput.toLowerCase());
      });
      this.setState({ aplicacionesFiltradas });
    } else {
      let aplicacionesFiltradas = [];
      this.setState({ aplicacionesFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { aplicacionesInactivas, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let inactivasFiltradas = aplicacionesInactivas.filter((value) => {
        return value.nombre.toLowerCase().includes(searchInput.toLowerCase());
      });
      this.setState({ inactivasFiltradas });
    } else {
      let inactivasFiltradas = [];
      this.setState({ inactivasFiltradas });
    }
  };

  changeOption = (option) => {
    this.setState({ option, inactivasFiltradas:[], aplicacionesFiltradas:[]  });
    if (option === "archivo") {
      this.getAplicacionesInactivas(this.state.dataOriginal);
    }
  };

  getAplicacionesInactivas = (data) => {
    const inactivas = data.filter((aplicacion) => {
      return aplicacion.activo === 0;
    });
    this.setState({ aplicacionesInactivas: inactivas });
  };

  render() {
    return (
      <>
      <Menu/>
      <Modal 
        modalInfo={this.state.modal} 
        setMostrarModal={(data) => {
          this.setState({ modal: data });
        }} 
      />
      {
        this.state.cargando && <Loading />
      }
        <div className={`navegacion`}>
          {
            this.state.aplicaciones?.length > 0 && this.state.tiposAutenticacion?.length > 0 ? (
              <>
                <div className="row posicionMenu">
                  <ul className="d-flex px-0 my-0">
                    <li
                      className="opcion-ruta"
                      onClick={() => this.changeOption("aplicaciones")}
                    >
                      <div
                        className={`nav-link nav-link-title active ps-0 ${
                          this.state.option === "aplicaciones"
                            ? " active border_menu"
                            : ""
                        }`}
                      >
                        <img src={APL} alt="app" className="icono-menu me-3" />
                        Aplicaciones
                      </div>
                    </li>
                    <li
                      className="opcion-ruta"
                      onClick={() => this.changeOption("archivo")}
                    >
                      <div
                        className={`nav-link active ps-0 ${
                          this.state.option === "archivo"
                            ? " active border_menu"
                            : ""
                        }`}
                      >
                        <img
                          src={ARCH}
                          alt="archivo"
                          className="icono-menu me-3"
                        />
                        Archivo
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="row border_vw pt-4 m-0">
                  <div className="col-12 p-0 contenedor-table">
                    {this.state.option === "archivo" ? (
                      <TablaArchivo
                        aplicaciones={
                          this.state.inactivasFiltradas &&
                          this.state.inactivasFiltradas.length
                            ? this.state.inactivasFiltradas
                            : this.state.aplicacionesInactivas
                        }
                        servicio={this.props.servicio}
                        marca={this.props.marca}
                        marcaNombre={this.state.marca}
                        tiposAutenticacion={this.state.tiposAutenticacion}
                        handleChange={this.handleChange}
                      ></TablaArchivo>
                    ) : (
                      <Tabla
                        aplicaciones={
                          this.state.aplicacionesFiltradas &&
                          this.state.aplicacionesFiltradas.length
                            ? this.state.aplicacionesFiltradas
                            : this.state.aplicaciones
                        }
                        servicio={this.props.servicio}
                        marca={this.props.marca}
                        marcaNombre={this.state.marca}
                        tiposAutenticacion={this.state.tiposAutenticacion}
                        handleChange={this.handleChange}
                      ></Tabla>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                {
                  !this.state.cargando && <NoInfoScreen />
                }
              </>
            )
          }
        </div>
      </>
    );
  }
}

export default Aplicacion;
